module.exports = __webpack_public_path__ + "img/search.78633067.png";